var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgExternalLink = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2199 2.08286V12.2971C13.2199 13.0664 12.5963 13.69 11.8271 13.69H1.61277C0.843503 13.69 0.21991 13.0664 0.21991 12.2971V2.08286C0.21991 1.3136 0.843503 0.690002 1.61277 0.690002H11.8271C12.5963 0.690002 13.2199 1.3136 13.2199 2.08286ZM10.6663 2.54715H7.41718C6.79872 2.54715 6.48629 3.29758 6.92472 3.73604L7.85282 4.66423L2.17905 10.338C2.04307 10.474 2.04307 10.6945 2.17905 10.8305L3.07945 11.7309C3.21545 11.8668 3.43593 11.8668 3.57191 11.7309L9.24565 6.05712L10.1739 6.98543C10.61 7.42148 11.3628 7.11528 11.3628 6.49296V3.24357C11.3628 2.85894 11.051 2.54715 10.6663 2.54715Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgExternalLink, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/externalLink.a75e6f18.svg";
export { ForwardRef as ReactComponent };